import API from '../../../../api/api'

export const uploadFiles = async (
  image: Blob | string,
  files: (Blob | string)[] = [],
  trainingId?: string,
) => {
  const stringFiles: string[] = []
  const blobFiles: Blob[] = []

  files.forEach((file) => {
    typeof file === 'string' ? stringFiles.push(file) : blobFiles.push(file)
  })

  const formData = new FormData()

  if (trainingId) {
    formData.append('trainingId', trainingId)
  }

  if (typeof image === 'object') {
    formData.append('image', image)
  }

  if (blobFiles.length) {
    blobFiles.forEach((file) => {
      formData.append('file', file)
    })
  }

  const jsonPayload = {
    ...(typeof image === 'string' ? { image } : {}),
    files: stringFiles,
  }

  if (!([...formData.entries()].length === 0)) {
    const response = await API.uploadEventImages(formData)

    if (response.data.image) {
      jsonPayload.image = response.data.image
    }

    if (response.data.files?.length) {
      jsonPayload.files = [...jsonPayload.files, ...response.data.files]
    }
  }

  return jsonPayload
}
